module.exports = __webpack_public_path__ + "img/icon-school2.c8aa43a3.png";